import { createContext, SetStateAction, Dispatch } from "react";

import { FormInstance } from "antd";

import { StepThreeForm } from "../../../../../utils";

import { GetCommertialsConditionsResponse, SelectOption } from "../../../../../../../../../shared/interfaces";
import { DataQuotation, InfoTable } from "../../interfaces";
import { QuotationButton } from "../../../../../shared";
import { AxiosResponse } from "axios";

interface StepThreeFormContextProps {
    
    stepThreeForm:            FormInstance<StepThreeForm> | undefined;

    optionsPaymentMethod:     Array<SelectOption>;

    getPaymentMethodDefault:  () => string | undefined;
    getPaymentMethodsList:    () => void;

    isPersonalDomestic:       boolean;
    setIsPersonalDomestic:    Dispatch<SetStateAction<boolean>>;

    primaData:                string;
    setPrimaData:             Dispatch<SetStateAction<string>>;

    sumInsuredByPerson:       InfoTable[];
    setSumInsuredByPerson:    Dispatch<SetStateAction<InfoTable[]>>;

    rightEmissionLife:        InfoTable[];
    setRightEmissionLife:     Dispatch<SetStateAction<InfoTable[]>>;

    commertialConditions:     GetCommertialsConditionsResponse | undefined;

    //* Methods
    getSumInsuredByPerson:    (_isPersonalDomestic: boolean) => Promise<void>;
    getEmissionLife:          () => Promise<void>;
    getCommertialConditions:  () => Promise<void>;

    quotationResponse?:             DataQuotation;
    setQuotationResponse:           Dispatch<SetStateAction<DataQuotation | undefined>>;

    labelButton:                    QuotationButton;
    setLabelButton:                 Dispatch<SetStateAction<QuotationButton>>;
    sendQuotationLifeObligatory:    () => Promise<AxiosResponse<any, any> | undefined>;

    handleOnClickQuotation:         () => Promise<void>;
}

export const StepThreeFormContext = createContext({} as StepThreeFormContextProps);